<template>
    <div>
        <b-form-group label="Exclusion des relances">
            <b-form-tags v-model="selectedUsers" no-outer-focus tag-variant="primary" separator=""
                :add-on-change="false">
              <template v-slot="{ tags, addTag, removeTag:removeTagSlot, disabled }">
              <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-1">
                        <li v-for="tag in tags" :key="tag" class="list-inline-item mb-1">
                            <b-form-tag :title="tag" :disabled="disabled" variant="primary" @remove="removeTag(tag,removeTagSlot)">
                                {{ tag }}
                            </b-form-tag>
                        </li>
                    </ul>

                    <b-dropdown size="sm" variant="outline-secondary" block menu-class="w-100"  v-model="dropdownOpen"
                                @click.stop>
                        <template v-slot:button-content>
                            <b-icon icon="tag-fill" /> Choisir des utilisateurs
                        </template>

                        <b-dropdown-form @submit.stop.prevent>
                            <b-form-group label-for="tag-search-input" label="Recherche" class="mb-0"
                                label-cols-md="auto" label-size="sm" :disabled="disabled" :description="searchDesc">
                                <b-form-input id="tag-search-input" v-model="search" type="search" size="sm"
                                    placeholder="Rechercher un utilisateur" autocomplete="off" />
                            </b-form-group>
                        </b-dropdown-form>

                        <b-dropdown-divider />

                        <div class="scroll-area" @scroll.passive="handleScroll">
                            <b-dropdown-item v-for="user in filteredUsers" :key="user.id"
                                @click="handleSelect(user, addTag)">
                                {{ user.fullName }}
                            </b-dropdown-item>

                            <b-dropdown-text v-if="isLoading">Chargement...</b-dropdown-text>
                            <b-dropdown-text v-else-if="filteredUsers.length === 0">
                                Aucun utilisateur trouvé
                            </b-dropdown-text>
                        </div>
                    </b-dropdown>
                    <b-dropdown-divider />
<!--                    <div class="text-right">-->
<!--                        <b-button variant="primary" @click=saveReminderBlocklist>-->
<!--                            Enregistrer-->
<!--                        </b-button>-->
<!--                    </div>-->
                </template>
            </b-form-tags>
        </b-form-group>
    </div>
</template>

<script>
import {
  BFormTags,
  BFormGroup,
  BDropdown,
  BDropdownForm,
  BFormInput,
  BDropdownDivider,
  BDropdownItem,
  BFormTag,
  BDropdownText,
  BIcon
} from 'bootstrap-vue'
import { getDisabledUsers,updateUsersReminderBlocklist } from '@/services/UserService'

export default {
  components: {
    BFormTags,
    BFormGroup,
    BDropdown,
    BDropdownForm,
    BFormInput,
    BDropdownDivider,
    BDropdownItem,
    BFormTag,
    BDropdownText,
    BIcon
  },
  data() {
    return {
      users: [],
      allUsers: [],
     // selectedUsersAll: [], // liste de fullName (string)
      selectedUsers: [], // liste de fullName (string)
      search: '',
      page: 0,
      pageSize: 20,
      total: 0,
      isLoading: false,
      dropdownOpen: true,

    }
  },
  computed: {
    filteredUsers() {
      const selectedNames = this.selectedUsers
      return this.users
        .filter(u => !selectedNames.includes(u.fullName))
        .filter(u => u.fullName.toLowerCase().includes(this.search.toLowerCase()))
    },
    searchDesc() {
      if (this.search && this.filteredUsers.length === 0) {
        return "Aucun résultat ne correspond à la recherche"
      }
      return ''
    }
  },
  watch: {
    search() {
      this.page = 0
      this.users = []
      this.total = 0
      this.fetchUsers()
    },
    filteredUsers(newList) {
      if (newList.length === 0 && this.users.length < this.total && !this.isLoading) {
        this.fetchUsers()
      }
    }
  },
  methods: {
    saveReminderBlocklist() {
      // Implémentez la logique pour enregistrer la liste de blocage des rappels
      updateUsersReminderBlocklist(this.allUsers)
        .then(() => {
          this.$bvToast.toast('Liste de blocage des rappels mise à jour avec succès.', {
            title: 'Succès',
            variant: 'success',
            solid: true
          })
        })
        .catch(err => {
          console.error("Erreur lors de la mise à jour de la liste de blocage", err)
          this.$bvToast.toast('Erreur lors de la mise à jour de la liste de blocage.', {
            title: 'Erreur',
            variant: 'danger',
            solid: true
          })
        })
    },
    handleScroll(event) {
      const el = event.target
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
        if (!this.isLoading && this.users.length < this.total) {
          this.fetchUsers()
        }
      }
    },
    handleSelect(user, addTag) {
      addTag(user.fullName) // stocke le nom


      this.allUsers.push(user) // garde la référence complète
      this.users = this.users.filter(u => u.id !== user.id)
      this.search = ''
      this.saveReminderBlocklist()
      this.dropdownOpen = true
    },
    removeTag(tag, removeTagSlot) {

      removeTagSlot(tag)
      this.$nextTick(() => {

      this.selectedUsers = this.selectedUsers.filter(t => t !== tag)
      this.allUsers = this.allUsers.filter(u => u.fullName !== tag)
      this.saveReminderBlocklist()

      })

    },

async fetchUsers() {
  if (this.isLoading) return
  this.isLoading = true
  try {
    const response = await getDisabledUsers(this.page, this.pageSize, this.search)

    // Pour les utilisateurs non sélectionnés (notSelected) : tableau de maps {id, fullName}
    if (Array.isArray(response.notSelected)) {
      const newUsers = response.notSelected.filter(
        u => !this.users.find(existing => existing.id === u.id)
      )
      this.users.push(...newUsers)
      //this.allUsers.push(...newUsers)
      this.total = response.total
      this.page++
    }

    // Pour les utilisateurs sélectionnés (selected) : tableau d'objets Users complets
    if (Array.isArray(response.selected)) {
      // On filtre ceux déjà dans selectedUsers (string list fullName)
      const newSelectedUsers = response.selected.filter(
        u => !this.selectedUsers.includes(u.fullName)
      )
      // On ajoute uniquement les fullName dans selectedUsers (tags)
      this.selectedUsers.push(...newSelectedUsers.map(u => u.fullName))

      // Optionnel : garder les infos complètes dans allUsers (si besoin)
      this.allUsers.push(...newSelectedUsers)
    }

  } catch (err) {
    console.error("Erreur chargement utilisateurs", err)
  } finally {
    this.isLoading = false
  }
},

mounted() {
  this.fetchUsers()
},

  },
  mounted() {
    this.fetchUsers()
  }
}
</script>

<style scoped>
.scroll-area {
  max-height: 200px;
  overflow-y: auto;
}
</style>
